import auth from '@/auth/authService';
import { nonPrintableCopyRegex } from '@/store/modules/Constants'

export class AppHelper {
  public static getBranchLinkAlias() {
    if (auth.dashboardEnv === 'production') {
      return 'post-signup-open';
    } else if (auth.dashboardEnv === 'develop' || auth.dashboardEnv === 'localhost') {
      return 'post-signup-open-dev';
    } else {
      return `post-signup-open-${auth.dashboardEnv}`;
    }
  }

  public static openJigSpaceUrl() {
    const profile: any = auth.profile
    const emailValue: string = profile ? profile.email : ''

    return `https://link.jig.space/${AppHelper.getBranchLinkAlias()}?email=${encodeURIComponent(emailValue)}&token=${encodeURIComponent(auth.accessToken || '')}`;
  }

  // TODO: when `team` tier is completely replaced to `starter` tier, we can safely remove this function
  public static getTierType(value: string) {
    if (value === 'team') {
      return 'starter'
    } else {
      return value
    }
  }

  public static stringSanitiser(value: string) {
    return value.replace(nonPrintableCopyRegex, '')
  }

  // So far we only have JSON safe object to copy. If object contains non-JSON-safe value (e.g., functions, undefined, NaN), or a Date objects (not Data string), we will need to write a proper deep copy function.
  public static deepCopyNestedJsonSafeObject(jsonSafeObject: any) {
    return JSON.parse(JSON.stringify(jsonSafeObject))
  }
}
